export default __webpack_public_path__ + "static/media/pa_7.e25011fc.mp3";